<template>
	<transition name="fade">
		<div v-show="show">
			<div class="loader"></div>
		</div>
	</transition>
</template>

<style lang="scss" scoped>

	.loader {
		height: 4px;
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		overflow: hidden;
		background-color: #ece9fc;
		z-index: 9999 !important;
	}
	.loader:before{
		display: block;
		position: fixed;
		content: "";
		left: -200px;
		width: 200px;
		height: 4px;
		background-color: #ff0060;
		animation: loading 2s linear infinite;
	}
	@keyframes loading {
		from {left: -200px; width: 30%;}
		50% {width: 30%;}
		70% {width: 70%;}
		80% { left: 50%;}
		95% {left: 120%;}
		to {left: 100%;}
	}
	
</style>

<script>
	import bus from '@/bus/event-bus.js'
	export default {
		data() {
			return {
				show: false
			}
		},
		mounted() {
			bus.$on('loading', (l) => {
				this.show = l;
			})
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/ui/LoadingBar.vue